import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  theme: process.env.VUE_APP_THEME=='dark' ? {
    primary:process.env.VUE_APP_THEME_PRIMARY ? process.env.VUE_APP_THEME_PRIMARY :  '#505050',
    accent: process.env.VUE_APP_THEME_ACCENT ? process.env.VUE_APP_THEME_ACCENT: '#606060',
    secondary:process.env.VUE_APP_THEME_SECONDARY ? process.env.VUE_APP_THEME_SECONDARY : '#404040',
    success: '#4CAF50',
    info: '#2196F3',
    warning: '#FB8C00',
    error: '#FF5252'
  } : {
    primary: process.env.VUE_APP_THEME_PRIMARY ? process.env.VUE_APP_THEME_PRIMARY : '#0066CC',
    secondary: process.env.VUE_APP_THEME_SECONDARY ? process.env.VUE_APP_THEME_SECONDARY: '#424242',
    accent: process.env.VUE_APP_THEME_ACCENT ? process.env.VUE_APP_THEME_ACCENT : '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  options: {
    customProperties: true
  },
  iconfont: 'fa',
})
